// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boards-pagination {\n  margin-top: 40px;\n  margin-bottom: 160px; }\n\nhr {\n  margin-top: 40px;\n  border-top: 2px solid #231f20; }\n\n.boards {\n  border-top: 3px solid #000; }\n  @media (max-width: 768px) {\n    .boards {\n      border-top: 1px solid #000; } }\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/member/community-board/community-list/community-list.component.scss
// module id = 955
// module chunks = 0